// src/features/inventory/hooks/useLotFiltering.js
import { useState, useEffect, useCallback } from 'react';
import { lotsAPI } from '../services/lots';
import { useApi } from '../../../hooks/api/useApi';

const DEBOUNCE_MS = 400;

export function useLotFiltering(initialState = {}) {
  const { loading, error, execute, clearError } = useApi();

  const [searchTerm, setSearchTerm] = useState(initialState.searchTerm || '');
  const [debouncedSearch, setDebouncedSearch] = useState(initialState.searchTerm || '');
  const [statusFilter, setStatusFilter] = useState(initialState.statusFilter || 'all');

  const [lots, setLots] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchTerm), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const loadLots = useCallback(async () => {
    const body = {};
    if (debouncedSearch.trim()) body.search_term = debouncedSearch.trim();
    if (statusFilter !== 'all') body.statuses = [statusFilter];

    const result = await execute(() => lotsAPI.filterLots(body));
    if (result.success) {
      setLots(result.data?.data || []);
    }
  }, [debouncedSearch, statusFilter, execute]);

  useEffect(() => {
    loadLots();
  }, [loadLots]);

  const hasActiveFilters = searchTerm !== '' || statusFilter !== 'all';

  const clearFilters = useCallback(() => {
    setSearchTerm('');
    setStatusFilter('all');
  }, []);

  return {
    lots,
    loading,
    error,
    clearError,
    searchTerm,
    statusFilter,
    hasActiveFilters,
    setSearchTerm,
    setStatusFilter,
    clearFilters,
    refreshData: loadLots,
  };
}
